
import React from 'react';
import { SettingsLayout } from '@/components/settings/layout';
import { useSettingsState } from '@/hooks/useSettingsState';

const Settings = () => {
  const { 
    activeTab, 
    setActiveTab, 
    editing, 
    handleEditToggle, 
    handleSave 
  } = useSettingsState();

  return (
    <SettingsLayout
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      editing={editing}
      handleEditToggle={handleEditToggle}
      handleSave={handleSave}
    />
  );
};

export default Settings;
